export default class BooleanFilter{
	constructor(){
		return (data) => {
				if (data) {
					return 'Si';
				}else{
					return 'No';
				}
		};
	}

	static filter(){
		return new BooleanFilter();
	}
}



// WEBPACK FOOTER //
// ./app/js/filters/booleanFilter.js